import React from "react";
import { useAtomValue, useAtom } from "jotai";
import { breadcrumbDisplayAtom } from "../store/atoms/derivedAtoms.js";
import { currentProjectIdAtom } from "../store/atoms/taskAtoms.js";
import { navigateToLevelAtom } from "../store/actions.js";
import "../styles/ProjectBreadcrumb.css";

const ProjectBreadcrumb = () => {
  const breadcrumb = useAtomValue(breadcrumbDisplayAtom);
  const currentProjectId = useAtomValue(currentProjectIdAtom);
  const [, navigateToLevel] = useAtom(navigateToLevelAtom);

  if (currentProjectId === null) {
    return null;
  }

  const handleNavigation = (item, index) => {
    if (index === breadcrumb.length - 1) return;

    let targetId;
    if (item.level === 0) {
      targetId = null;
    } else {
      targetId = item.id;
    }

    navigateToLevel({ id: targetId, level: item.level });
  };

  return (
    <div className="project-breadcrumb">
      {breadcrumb.map((item, index) => (
        <React.Fragment key={item.id || "slate"}>
          {index < breadcrumb.length - 1 ? (
            <button
              className="breadcrumb-link"
              onClick={() => handleNavigation(item, index)}
              title={`Navigate to ${item.name}`}
            >
              {item.name}
            </button>
          ) : (
            <span className="breadcrumb-current">{item.name}</span>
          )}
          {index < breadcrumb.length - 1 && (
            <span className="breadcrumb-separator"> / </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProjectBreadcrumb;
